import { useState, useEffect } from 'react';
import { discountService, ActiveSaleInfo } from '@/services/discount.service';

/**
 * Hook to fetch and cache active sale information
 * Used to display sale badges on product cards when a sale is active
 */
export function useSaleInfo() {
  const [saleInfo, setSaleInfo] = useState<ActiveSaleInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSaleInfo = async () => {
      try {
        setLoading(true);
        const response = await discountService.getActiveSaleInfo();
        if (response.success && response.data) {
          setSaleInfo(response.data);
        } else {
          setError(response.error || 'Failed to fetch sale info');
        }
      } catch (err) {
        setError('Failed to fetch sale info');
      } finally {
        setLoading(false);
      }
    };

    fetchSaleInfo();
  }, []);

  return {
    saleInfo,
    isSaleActive: saleInfo?.is_sale_active ?? false,
    hasDiscountCode: Boolean(saleInfo?.system_discount_code),
    loading,
    error,
  };
}

export default useSaleInfo;
